import {
  Directive,
  OnInit,
  Input,
  OnDestroy,
  ElementRef
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import $ from 'jquery';
import * as moment from 'vendors/moment-locale-th';
import '../../../vendors/datepicker-custom.js';

import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs/Rx';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { LANG_EN_TRANS } from '../../../translation/lang-en';
import { LANG_TH_TRANS } from '../../../translation/lang-th';
import { Language } from 'app/model/constant';
import { DataMouseEvent } from '../../utilities/act-map/services/google-maps-types';

@Directive({
  selector: '[daterangepicker]'
})
export class DaterangepickerDirective implements OnInit, OnDestroy {
  @Input('daterangepicker') state: any;
  @Input('formControlFrom') formControlFrom: FormControl;
  @Input('formControlTo') formControlTo: FormControl;

  @Input() defaultStartDate: any;
  @Input() defaultEndDate: any;
  @Input() id: any;
  @Input() syncToId: any;
  @Input() label: any;
  @Input() isFirst: boolean = true;
  @Input() ignoreLimit: boolean = true;
  @Input() allowSameDate: boolean = false;
  @Input() name: any;
  @Input() section: any;
  @Input() canSelectPastDate: boolean = false;
  @Input() haveDefaultDate: boolean = true;
  @Input() opens = 'right';

  private subscription: Subscription = null;

  private suggestionData: any = '';
  private actionSelectItem: boolean = false;
  private hasSelectedAll: boolean = false;
  private dataSelected: boolean;
  private searchData: any = {'hotel': {}};
  private hotelDestinationTitle = new Subject<any>();
  private totalProduct: any;

  constructor(
    private elementRef: ElementRef,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // Get Translate
    const translate = (value) => {
      switch (this.appConfigService.getLanguage()) {
        case Language.th:
          return LANG_TH_TRANS[value];
        case Language.en:
          return LANG_EN_TRANS[value];
      }
    }

    let locale = {
      daysOfWeek: {
        th: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        en: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      },
      monthNames: {
        th: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        en: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      }
    };

    let _self = this;
    $(function() {
      let $element = $(_self.elementRef.nativeElement);
      let $iconElem = undefined;
      let $picker = undefined;
      let $syncElem = undefined;
      let $pickerMask = undefined;
      let $syncMask = undefined;

      let vm = {
        displayFormatDate: 'dd DD MMM YYYY',
        valueFormatDate: 'YYYY-MM-DD',
        defaultStartDate: _self.haveDefaultDate ? (_self.defaultStartDate ? moment(_self.defaultStartDate, 'YYYY-MM-DD') : moment()) : undefined,
        defaultEndDate: _self.haveDefaultDate ? (_self.defaultEndDate ? moment(_self.defaultEndDate, 'YYYY-MM-DD') : moment().add(1, 'days')) : undefined,
        pickerId: _self.id,
        syncId: _self.syncToId,
        label: translate(_self.label),
        isStartElement: _self.isFirst,
        ignoreLimit: _self.ignoreLimit,
        allowSameDate: _self.allowSameDate,
        name: _self.name,
        section: _self.section,
        hiddenField: _self.id + '_submit',
        hiddenSyncField: _self.syncToId + '_submit',
        selectState: { CHECKIN: 'SELECT_CHECKIN', CHECKOUT: 'SELECT_CHECKOUT' },
        opens: _self.opens
      }

      function pickerInstance() {
        return $pickerMask.data('daterangepicker');
      }
      function syncInstance() {
        if ($syncMask) {
          return $syncMask.data('daterangepicker');
        } else {
          return false;
        }
      }
      function getRangeDate() {
        return {
          startDate: pickerInstance().startDate,
          endDate: pickerInstance().endDate
        };
      }

      function logDateRange() {
        var data = getRangeDate();
        var logDate = { startDate: data.startDate.format(vm.displayFormatDate), endDate: data.endDate.format(vm.displayFormatDate) };
      }

      /*********************************
       * update date
       ******************************** */
      function updateDisplayDate(isDefault = false) {
        let rangeDate = getRangeDate();
        let selfDate = vm.isStartElement ? rangeDate.startDate.clone() : rangeDate.endDate.clone();
        let syncDate = vm.isStartElement ? rangeDate.endDate.clone() : rangeDate.startDate.clone();

        // update self input
        let lang = _self.appConfigService.getLanguage();
        let selfDateOutput = _self.utilitiesService.getOtaFormatYear(lang, selfDate);
        $picker.val(selfDateOutput);
        $('input[name=' + vm.hiddenField + ']').val(selfDateOutput);

        // update sync input
        if (!isDefault) {
            let syncDateOutput = _self.utilitiesService.getOtaFormatYear(lang, syncDate);

            $syncElem.val(syncDateOutput);
            $('input[name=' + vm.hiddenSyncField + ']').val(syncDateOutput);
        }

        logDateRange();
      }

      function getCustomPosition() {
        let selfOffset = $element.offset();
        let syncOffset = $("#" + vm.syncId).offset();

        return {
          top: 0,
          left: vm.isStartElement ? 0 : Math.abs(syncOffset.left - (selfOffset.left)),
        }
      }

      function createDateRangePicker() {
        let template = '<input type="text" class="ota-picker-mask" id="' + vm.pickerId + '-mask" />';
        let hiddenField = '<input type="hidden" name="' + vm.hiddenField + '" />';
        // let icon = '<i class="fa fa-calendar calendar-'+ vm.pickerId +'"></i>';
        let icon = '<i class="calendar-icon calendar-'+ vm.pickerId +'"></i>';

        let _lang = _self.appConfigService.getLanguage();

        let $parentElem = $element.parent();

        let minDate = _self.canSelectPastDate ? moment('2016-01-01') : moment();
        let options = {
          "id": vm.pickerId,
          "showDropdowns": false,
          "autoApply": true,
          "showCustomRangeLabel": false,
          "startDate": vm.defaultStartDate,
          "endDate": vm.defaultEndDate,
          "minDate": minDate,
          "maxDate": vm.name === 'checkInDate'? moment().add(1, 'year').subtract(1, 'day'): moment().add(1, 'year'),
          "pickerLabel": vm.label,
          "isFirstComponent": vm.isStartElement,
          "locale": {
            "daysOfWeek": locale.daysOfWeek[_lang],
            "monthNames": locale.monthNames[_lang],
          },
          "allowSameDate": vm.allowSameDate,
          "customHandler": onDatePickerEventHandler,
          "customPosition": getCustomPosition(),
          "lang": _lang,
          "opens": vm.opens
        };

        /*
        if (!vm.ignoreLimit) {
            options = angular.extend(options, { "dateLimit": { "days": 30 }});
        }
        */

        $picker = $("#" + vm.pickerId);
        $pickerMask = $(template);
        $parentElem.append(icon);
        $parentElem.append(hiddenField);
        $parentElem.append($pickerMask);
        $iconElem = $('.calendar-' + vm.pickerId);

        checkStartDateEndDate();

        $pickerMask.daterangepicker(options);

        if (vm.defaultStartDate || vm.defaultEndDate) {
          updateDisplayDate(true);
        }
      }

      function setSelectionToPickerWithState(state, isSetAllComponent) {
        pickerInstance().setSelectionState(state);
        if (isSetAllComponent) {
          syncInstance().setSelectionState(state);
        }
      }

      function focusEndDatePicker(data) {
        if (vm.isStartElement) {
          pickerInstance().hide();
          if ( !(pickerInstance().getStartDate().format('DD MM YYYY') === moment().add(1, 'year').subtract(1, 'day').format('DD MM YYYY')) ) {
            syncInstance().show();
          }
          setSelectionToPickerWithState(vm.selectState.CHECKOUT, true);

          // set disable date
          syncInstance().setMinDate(data.startDate.clone());
          syncInstance().setMaxDate(false);
          syncInstance().updateView();
        }
      }

      function checkStartDateEndDate() {
        if (vm.defaultStartDate && !vm.defaultStartDate.isValid()) {
          vm.defaultStartDate = moment();
        }
        if ((vm.defaultEndDate && !vm.defaultEndDate.isValid()) ||
            (vm.defaultStartDate && vm.defaultEndDate && vm.defaultStartDate.isSame(vm.defaultEndDate))) {
          vm.defaultEndDate = vm.allowSameDate ? vm.defaultStartDate : vm.defaultEndDate.add(1, 'days');
        }
      }

      function onSetStartDateComplete(data) {
        focusEndDatePicker(data);
      }
      function onSetEndDateComplete(data) {
        setSelectionToPickerWithState(vm.selectState.CHECKIN, true);
      }
      function onSetBothDateComplete(data) {
        focusEndDatePicker(data);
      }

      function updateSyncPicker() {
          let rangeDate = getRangeDate();
          syncInstance().setStartDate(rangeDate.startDate);
          syncInstance().setEndDate(rangeDate.endDate);
          syncInstance().updateView();
      }

      function syncToScope() { // update date to scope
        let rangeDate = getRangeDate();

        switch (vm.section) {
          case 'searchProduct':
            _self.searchData.hotel.dateFrom = rangeDate.startDate.format(vm.valueFormatDate);
            _self.searchData.hotel.dateTo = rangeDate.endDate.format(vm.valueFormatDate);
            break;
          case 'searchMyBooking':
          case 'exportBookingReport':
            _self.formControlFrom.setValue(rangeDate.startDate.format(vm.valueFormatDate));
            _self.formControlTo.setValue(rangeDate.endDate.format(vm.valueFormatDate));
        }
      }

      function onPickerChange() {
        updateDisplayDate();
        updateSyncPicker();
        syncToScope();
      }

      function onDatePickerEventHandler(type, data) {
        switch (type) {
          case 'SET_START_DATE_COMPLETE':     onSetStartDateComplete(data);       break;
          case 'SET_END_DATE_COMPLETE':       onSetEndDateComplete(data);         break;
          case 'SET_BOTH_DATE_COMPLETE':      onSetBothDateComplete(data);        break;
          default: break;
        }
        onPickerChange();

        var logDate = { startDate: data.startDate.format(vm.displayFormatDate), endDate: data.endDate.format(vm.displayFormatDate) };
      }

      function onElementClick() {
        if ( syncInstance() && syncInstance().isPickerShowing()) {
          syncInstance().toggle();
        }
        pickerInstance().toggle();
      }

      function registerEvent() {
        var _eventFire = 'click';
        if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
          _eventFire = 'touchend';
        }
        $element.on(_eventFire, onElementClick);
        $iconElem.on(_eventFire, onElementClick);

        // $pickerMask.on('change.daterangepicker', onPickerChange);
      }

      function initSyncPicker() {
        $syncElem = $("#" + vm.syncId);
        $syncMask = $("#" + vm.syncId + "-mask");

        if (vm.isStartElement) {
          syncInstance().setMinDate(syncInstance().startDate);
        }
      }


      function initialize() {
        createDateRangePicker();
        registerEvent();

        setTimeout(initSyncPicker, 100);
      }
      setTimeout(initialize);

      // change lang
      _self.appConfigService.getLanguageObs().subscribe(
      lang => {
        $pickerMask.data('daterangepicker').setLocale(
          translate(_self.label),
          locale.daysOfWeek[lang],
          locale.monthNames[lang],
          lang
        );
        updateDisplayDate();
      });

    }); // end jquery function call
  }

  ngOnDestroy(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/daterangepicker/daterangepicker.directive.ts